<template>   
    <div class="table-box" :style="getStyle()">
       <div class="header" v-show="optionConfig.options.headShow" :style="getHeadStyle()">
           <div class="header-item" v-for="(item,i) in headData" :key="i" :style="headRow(i)">
               <span>{{ item }}</span>
           </div>
       </div>
       <div class="tbody" :style="getBdStyle()">
            <vue3-seamless-scroll
            :modelValue="optionConfig.options.isScroll"
            :list="tableData"
            :hover="true"
            direction="up"
            :isWatch="true"
            :step="1"
            :copyNum="copyNum"
            :single-height="optionConfig.options.lineH"
            :single-waitTime="optionConfig.options.waitTime"
            >
                <div class="rows">
                    <ul>
                        <li class="rows-list" v-for="(row,i) in tableData" :key="i" :style="getItemStyle(i)">
                            <div class="rows-item" v-for="(item,key,j) in row" :key="key" :style="headRow(j)">
                                <span>{{ item }}</span>
                            </div>                    
                        </li>
                    </ul>
                </div>
            </vue3-seamless-scroll>
        </div>
    </div>
</template>

<script setup>
import { ref,reactive,computed,watch,onMounted } from 'vue'
import { useStore } from 'vuex';
import { Vue3SeamlessScroll } from "vue3-seamless-scroll";
const props = defineProps({
    index:{
        type:Number||String,
        default:0
    }
})
const store = useStore()
const componentList = computed(() => store.state.chartData.componentList);
const optionConfig = reactive(componentList.value[props.index].config);
const headData = ref([])
const colWidths = ref([])
const copyNum = ref(1)
const tableData = ref([
    {"date":"2013-09-12","address":"北京市海淀区1","name":"王小虎1"},
    {"date":"2013-09-12","address":"北京市海淀区2","name":"王小虎2"},
    {"date":"2013-09-12","address":"北京市海淀区3","name":"王小虎3"},
    {"date":"2013-09-12","address":"北京市海淀区4","name":"王小虎4"},
    {"date":"2013-09-12","address":"北京市海淀区5","name":"王小虎5"},
    {"date":"2013-09-12","address":"北京市海淀区6","name":"王小虎6"}
])
const getNum = (data)=>{
    const length = data.length;
    const renderH = optionConfig.options.lineH*length;
    copyNum.value = Math.ceil(optionConfig.baseConfig.height/renderH);
}
watch(
    ()=>optionConfig.options,
    (newVal)=>{
       headData.value = newVal.headRows.split(',')
       colWidths.value = newVal.colWidth.split(',')
    },{
       deep:true,
       immediate: true
    }
)
watch(
    ()=>componentList.value[props.index].data,
    (newVal)=>{
        if(newVal){
            tableData.value = newVal.list;
            getNum(tableData.value)
        }       
    },{
       deep:true,
       immediate: true
    }
)
watch(
    ()=>optionConfig.options.isScroll,
    (newVal)=>{
        if(newVal){
            getNum(tableData.value)     
        }
    },{
       deep:true,
       immediate: true
    }
)
const getStyle = ()=>{
    return {
        width:`${optionConfig.baseConfig.width}px`,
        height:`${optionConfig.baseConfig.height}px`,
        left:`${optionConfig.baseConfig.left}px`,
        top:`${optionConfig.baseConfig.top}px`,
        position:'relative'
    }
}
const getHeadStyle = ()=>{
    return {
        'height':`${optionConfig.options.headLineH}px`,
        'line-height':`${optionConfig.options.headLineH}px`,
        'background-color':`${optionConfig.options.headBg}`,
        'color':`${optionConfig.options.headColor}`,
        'font-size':`${optionConfig.options.headFontSize}px`,
        'text-align':`${optionConfig.options.headAlign}`,
    }
}
const getBdStyle = ()=>{
    const {headShow,headLineH} = optionConfig.options;
    const calH = headShow?headLineH:0;
    return {
        // 'height':`calc(${optionConfig.baseConfig.height}px - ${calH}px)`,
        'padding-top':`${calH}px`
    }
}
const getItemStyle = (i)=>{
    return {
        'height':`${optionConfig.options.lineH}px`,
        'line-height':`${optionConfig.options.lineH}px`,
        'background-color':i%2?`${optionConfig.options.evenBgc}`:`${optionConfig.options.oddBgc}`,
        'color':`${optionConfig.options.fontColor}`,
        'font-size':`${optionConfig.options.fontSize}px`,
        'text-align':`${optionConfig.options.bodyAlign}`
    }
}
const headRow = (i)=>{
    return {
        width:`${colWidths.value[i]}px`
    }
}
onMounted(()=>{
    getNum(tableData.value)
})
</script>

<style lang="less" scoped>
ul,li{margin:0;padding:0;}
.table-box{background:#fff;overflow:hidden;display:flex;flex-direction:column;}
.header{
    width:100%;
    display: flex;
    flex-direction: row;   
    text-align: center;
    position: absolute;
    left:0;
    top:0;
    z-index:10;
    .header-item{
        transition: all 0.3s;
    }
}
.tbody{
    flex:1;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar { width:0!important }  
}
.rows {
    overflow: hidden;
    .rows-list {
      display: flex;
      flex-direction: row;
      overflow: hidden;
    }
    .rows-item{
        transition: all 0.3s;
    }
}
</style>
